import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";

/**
 * Controlled collapsible section
 *
 * @param {object} props
 * @param {string} props.title
 * @param {string} props.sectionKey
 * @param {boolean} props.isOpen
 * @param {(sectionKey: string) => void} props.onToggle
 * @param {boolean} [props.withContainer=true] - if true, wraps in dashboard-container classes
 * @param {React.ReactNode} props.children
 * @param {string} [props.summary] - shown when collapsed
 * @param {React.ReactNode} [props.actions] - icons/buttons rendered right of title, left of chevron
 */
const CollapsibleSection = ({
  title,
  sectionKey,
  isOpen,
  onToggle,
  withContainer = true,
  children,
  summary,
  actions
}) => {
  // Small safety: ensure isOpen is always boolean-ish
  const open = !!isOpen;

  // AI-CONTEXT: See docs/pitfalls.md#state-component-defined-in-render
  // Do NOT define Wrapper as a component inside render — a new component
  // identity on every render makes React unmount/remount the entire subtree,
  // which loses focus and resets scroll position. Inline the wrapper instead.
  const inner = (
    <>
      <div className="collapsible-section-header" onClick={() => onToggle(sectionKey)}>
        <h2>{title}</h2>
        {!open && summary && (
          <h3 className="collapsible-section-summary">{summary}</h3>
        )}
        {actions && (
          <div className="collapsible-section-actions" onClick={(e) => e.stopPropagation()}>
            {actions}
          </div>
        )}
        {open ? <KeyboardArrowUpOutlinedIcon /> : <KeyboardArrowDownOutlinedIcon />}
      </div>

      {open && <div>{children}</div>}
    </>
  );

  if (!withContainer) return inner;
  return <div className="dashboard-container modal-content-container">{inner}</div>;
};

export default CollapsibleSection;
